// apps/web/src/components/LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css';

/**
 * Simple loading spinner component
 * @param {Object} props
 * @param {'small'|'medium'|'large'} props.size - Size of the spinner
 * @param {'white'|'primary'|'dark'} props.variant - Color variant
 * @param {string} props.className - Additional CSS classes
 */
export function Spinner({ size = 'medium', variant = 'white', className = '' }) {
  const sizeClass = size === 'large' ? 'Spinner-large' : '';
  const variantClass = variant === 'primary' ? 'Spinner-primary' : variant === 'dark' ? 'Spinner-dark' : '';

  return (
    <span
      className={`Spinner ${sizeClass} ${variantClass} ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}

/**
 * Inline loading indicator with text
 */
export function InlineLoading({ text = 'Loading...' }) {
  return (
    <div className="InlineLoading">
      <Spinner size="small" variant="primary" />
      <span>{text}</span>
    </div>
  );
}

/**
 * Full-screen loading overlay
 */
export function LoadingOverlay({ visible = false }) {
  if (!visible) return null;

  return (
    <div className="LoadingOverlay">
      <Spinner size="large" variant="white" />
    </div>
  );
}

/**
 * Button with loading state
 * Wraps children and shows spinner when loading
 */
export function LoadingButton({
  loading = false,
  disabled = false,
  onClick,
  className = '',
  type = 'button',
  children
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${className} ${loading ? 'Button-loading' : ''}`}
    >
      {children}
    </button>
  );
}

export default Spinner;
